var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 289,
    viewBox: "0 0 325 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_578_5674)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.457 80.7021C142.457 80.7021 144.527 108.668 156.169 115.21C156.169 115.21 118.814 108.768 109.623 94.7951C100.432 80.822 142.457 80.7021 142.457 80.7021Z",
    fill: "url(#paint0_linear_578_5674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.661 163.092C202.664 169.385 208.125 167.617 212.225 173.779C214.026 176.416 214.869 179.588 214.616 182.769C214.276 185.713 212.96 188.459 210.875 190.569C202.994 198.2 181.291 188.871 168.87 178.674C166.16 176.446 158.869 170.483 160.359 166.239C160.959 164.501 162.819 163.642 164.159 163.042C170.02 160.386 176.191 162.134 179.661 163.092Z",
    fill: "url(#paint1_linear_578_5674)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.74 8.55957H245.84V40.6707H250.74V8.55957Z",
    fill: "url(#paint2_linear_578_5674)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265.212 37.3049H231.378C228.881 37.3049 226.857 39.3262 226.857 41.8195V53.8948C226.857 56.3881 228.881 58.4094 231.378 58.4094H265.212C267.709 58.4094 269.733 56.3881 269.733 53.8948V41.8195C269.733 39.3262 267.709 37.3049 265.212 37.3049Z",
    fill: "url(#paint3_linear_578_5674)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.51 47.4026H262.033C270.303 47.3921 278.495 49.0099 286.139 52.1634C293.783 55.3169 300.729 59.9443 306.581 65.7809C312.433 71.6176 317.076 78.549 320.243 86.1787C323.41 93.8085 325.041 101.987 325.041 110.247V128.594C325.041 137.961 321.315 146.944 314.683 153.567C308.051 160.191 299.056 163.912 289.676 163.912H206.956C197.577 163.912 188.582 160.191 181.95 153.567C175.318 146.944 171.592 137.961 171.592 128.594V110.247C171.592 93.5793 178.222 77.5947 190.023 65.8092C201.824 54.0237 217.83 47.4026 234.52 47.4026H234.51Z",
    fill: "url(#paint4_linear_578_5674)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.866 125.248C298.83 126.243 296.593 126.759 294.326 126.757H202.254C199.987 126.759 197.75 126.243 195.713 125.248C193.385 124.185 191.454 122.413 190.197 120.187C188.939 117.96 188.419 115.393 188.713 112.853L188.763 112.484C191.123 95.4045 206.615 82.2804 225.607 81.2916C233.608 80.8721 242.069 80.6624 250.86 80.7123C257.748 80.7523 264.415 80.942 270.863 81.2816C289.925 82.2804 305.527 95.3446 307.867 112.484V112.853C308.163 115.393 307.645 117.962 306.387 120.189C305.129 122.416 303.196 124.188 300.866 125.248Z",
    fill: "url(#paint5_linear_578_5674)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M224.028 122.991C233.617 122.991 241.39 115.228 241.39 105.652C241.39 96.0759 233.617 88.313 224.028 88.313C214.439 88.313 206.666 96.0759 206.666 105.652C206.666 115.228 214.439 122.991 224.028 122.991Z",
    fill: "url(#paint6_radial_578_5674)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.028 118.097C230.91 118.097 236.489 112.525 236.489 105.652C236.489 98.7788 230.91 93.207 224.028 93.207C217.146 93.207 211.566 98.7788 211.566 105.652C211.566 112.525 217.146 118.097 224.028 118.097Z",
    fill: "#EEFDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.028 116.099C229.805 116.099 234.489 111.422 234.489 105.652C234.489 99.882 229.805 95.2046 224.028 95.2046C218.25 95.2046 213.566 99.882 213.566 105.652C213.566 111.422 218.25 116.099 224.028 116.099Z",
    fill: "url(#paint7_linear_578_5674)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.728 102.945C230.73 103.713 230.504 104.463 230.078 105.102C229.652 105.741 229.046 106.239 228.337 106.534C227.627 106.828 226.846 106.906 226.093 106.757C225.339 106.608 224.647 106.238 224.103 105.696C223.56 105.153 223.19 104.462 223.041 103.709C222.891 102.956 222.969 102.176 223.264 101.468C223.559 100.759 224.058 100.154 224.698 99.729C225.337 99.304 226.089 99.0781 226.857 99.0801C227.883 99.0827 228.866 99.4908 229.591 100.215C230.316 100.939 230.725 101.921 230.728 102.945Z",
    fill: "#EEFDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M222.478 115.221C223.334 115.221 224.028 114.527 224.028 113.672C224.028 112.817 223.334 112.124 222.478 112.124C221.622 112.124 220.928 112.817 220.928 113.672C220.928 114.527 221.622 115.221 222.478 115.221Z",
    fill: "#EEFDFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M218.646 111.355C218.646 111.509 218.6 111.66 218.515 111.788C218.429 111.916 218.307 112.016 218.165 112.075C218.022 112.134 217.865 112.149 217.714 112.119C217.563 112.089 217.424 112.015 217.314 111.906C217.205 111.797 217.131 111.658 217.101 111.507C217.071 111.356 217.086 111.199 217.145 111.057C217.204 110.915 217.304 110.793 217.433 110.707C217.561 110.622 217.712 110.576 217.866 110.576C217.968 110.576 218.07 110.596 218.165 110.635C218.259 110.675 218.345 110.732 218.418 110.804C218.49 110.877 218.548 110.963 218.587 111.057C218.626 111.152 218.646 111.253 218.646 111.355Z",
    fill: "#EEFDFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M270.923 122.991C280.512 122.991 288.285 115.228 288.285 105.652C288.285 96.0759 280.512 88.313 270.923 88.313C261.334 88.313 253.561 96.0759 253.561 105.652C253.561 115.228 261.334 122.991 270.923 122.991Z",
    fill: "url(#paint8_radial_578_5674)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.922 118.097C277.805 118.097 283.384 112.525 283.384 105.652C283.384 98.7788 277.805 93.207 270.922 93.207C264.04 93.207 258.461 98.7788 258.461 105.652C258.461 112.525 264.04 118.097 270.922 118.097Z",
    fill: "#EEFDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M270.924 116.099C276.702 116.099 281.385 111.422 281.385 105.652C281.385 99.882 276.702 95.2046 270.924 95.2046C265.147 95.2046 260.463 99.882 260.463 105.652C260.463 111.422 265.147 116.099 270.924 116.099Z",
    fill: "url(#paint9_linear_578_5674)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.624 102.945C277.626 103.713 277.4 104.463 276.974 105.102C276.549 105.741 275.943 106.239 275.233 106.534C274.524 106.828 273.743 106.906 272.989 106.757C272.235 106.608 271.543 106.238 271 105.696C270.457 105.153 270.087 104.462 269.937 103.709C269.788 102.956 269.866 102.176 270.161 101.468C270.456 100.759 270.954 100.154 271.594 99.729C272.234 99.304 272.985 99.0781 273.754 99.0801C274.779 99.0827 275.762 99.4908 276.488 100.215C277.213 100.939 277.622 101.921 277.624 102.945Z",
    fill: "#EEFDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.372 115.221C270.229 115.221 270.923 114.527 270.923 113.672C270.923 112.817 270.229 112.124 269.372 112.124C268.516 112.124 267.822 112.817 267.822 113.672C267.822 114.527 268.516 115.221 269.372 115.221Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265.543 111.355C265.543 111.509 265.497 111.66 265.411 111.788C265.325 111.916 265.204 112.016 265.061 112.075C264.919 112.134 264.762 112.149 264.61 112.119C264.459 112.089 264.32 112.015 264.211 111.906C264.102 111.797 264.028 111.658 263.997 111.507C263.967 111.356 263.983 111.199 264.042 111.057C264.101 110.915 264.201 110.793 264.329 110.707C264.457 110.622 264.608 110.576 264.763 110.576C264.865 110.576 264.966 110.596 265.061 110.635C265.156 110.675 265.242 110.732 265.314 110.804C265.387 110.877 265.444 110.963 265.483 111.057C265.522 111.152 265.543 111.253 265.543 111.355Z",
    fill: "#EEFDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M254.571 6.42231C254.571 7.66287 254.203 8.87558 253.513 9.90707C252.823 10.9386 251.842 11.7425 250.694 12.2173C249.546 12.692 248.284 12.8162 247.065 12.5742C245.847 12.3322 244.728 11.7348 243.849 10.8576C242.971 9.98035 242.373 8.86272 242.13 7.64599C241.888 6.42926 242.012 5.16809 242.488 4.02196C242.963 2.87583 243.768 1.89621 244.801 1.20699C245.834 0.517772 247.048 0.149902 248.291 0.149902C249.956 0.149902 251.554 0.810743 252.732 1.98705C253.91 3.16335 254.571 4.75876 254.571 6.42231Z",
    fill: "url(#paint10_linear_578_5674)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.651 3.99512C252.651 4.37242 252.539 4.74126 252.329 5.05497C252.119 5.36869 251.82 5.61321 251.471 5.75759C251.122 5.90198 250.738 5.93976 250.368 5.86615C249.997 5.79254 249.657 5.61085 249.39 5.34406C249.122 5.07726 248.94 4.73735 248.867 4.36729C248.793 3.99723 248.831 3.61366 248.975 3.26508C249.12 2.91649 249.365 2.61855 249.679 2.40893C249.993 2.19931 250.363 2.08743 250.74 2.08743C250.992 2.0861 251.241 2.13454 251.473 2.22995C251.705 2.32535 251.916 2.46582 252.094 2.64323C252.272 2.82064 252.412 3.03146 252.508 3.26351C252.603 3.49556 252.652 3.74423 252.651 3.99512Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M302.337 67.4983C302.427 70.4247 300.027 73.9305 297.287 74.2301C294.726 74.5098 292.676 71.883 290.556 69.2362C288.435 66.5894 283.915 59.7277 285.725 57.79C288.125 55.1832 302.147 60.5966 302.337 67.4983Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.874 56.3418C280.078 56.3418 281.054 55.3669 281.054 54.1644C281.054 52.9619 280.078 51.9871 278.874 51.9871C277.669 51.9871 276.693 52.9619 276.693 54.1644C276.693 55.3669 277.669 56.3418 278.874 56.3418Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M302.038 108.099C301.337 108.588 296.457 98.6604 283.365 90.0609C278.755 87.0645 274.214 84.8771 274.484 84.2479C274.754 83.6187 279.875 84.7972 283.975 86.6949C297.037 92.7476 302.858 107.51 302.038 108.099Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M268.484 43.5573C268.334 43.5573 268.234 42.6583 267.484 41.25C267.257 40.8246 267.003 40.4142 266.724 40.0215C265.403 38.2137 260.953 38.2537 260.603 38.2537C253.602 38.3136 249.191 37.8741 249.191 37.9241C249.191 37.974 252.452 37.9241 254.832 37.8442C261.563 37.7043 265.573 37.3448 267.294 39.1426C267.754 39.6443 268.116 40.2268 268.364 40.8605C268.834 42.1789 268.674 43.5273 268.484 43.5573Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.033 134.198C266.935 135.005 266.561 135.753 265.974 136.317C265.387 136.881 264.624 137.226 263.813 137.294L240.81 139.511C240 139.601 239.184 139.408 238.501 138.966C237.817 138.523 237.308 137.859 237.059 137.084C236.836 136.366 236.669 135.631 236.559 134.887C236.544 134.783 236.55 134.678 236.576 134.577C236.603 134.476 236.65 134.381 236.715 134.299C236.779 134.217 236.86 134.148 236.952 134.098C237.044 134.048 237.145 134.017 237.249 134.008L266.253 131.221C266.354 131.21 266.456 131.22 266.552 131.251C266.649 131.282 266.737 131.333 266.813 131.401C266.894 131.466 266.959 131.548 267.004 131.641C267.049 131.735 267.072 131.837 267.073 131.94C267.115 132.693 267.101 133.447 267.033 134.198Z",
    fill: "#EEFDFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.034 134.198C266.664 137.688 265.107 140.947 262.621 143.43C260.136 145.912 256.874 147.469 253.378 147.839C249.883 148.209 246.366 147.372 243.415 145.465C240.463 143.559 238.255 140.699 237.16 137.364C237.459 138.067 237.976 138.655 238.635 139.042C239.294 139.429 240.06 139.593 240.821 139.511L263.823 137.294C264.633 137.224 265.394 136.878 265.979 136.314C266.563 135.751 266.936 135.003 267.034 134.198Z",
    fill: "url(#paint11_linear_578_5674)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M303.276 185.775C303.276 185.985 303.276 186.194 303.276 186.384C303.217 187.745 302.965 189.09 302.526 190.379C296.196 209.746 292.395 219.904 287.034 228.144C286.124 229.562 285.154 230.93 284.114 232.269C282.754 234.056 281.274 235.804 279.614 237.602C275.943 241.597 270.382 243.405 268.612 244.024C262.061 246.332 256.271 245.912 252.43 245.952H251.76C247.9 245.952 242.119 246.332 235.568 244.024C233.778 243.405 228.207 241.597 224.567 237.602C214.456 226.615 210.565 217.497 201.704 190.409C201.284 189.191 201.035 187.92 200.964 186.634C200.934 186.112 200.934 185.588 200.964 185.066C201.241 181.636 202.584 178.378 204.804 175.747C206.818 173.315 209.347 171.361 212.21 170.026C215.073 168.691 218.197 168.008 221.356 168.026L252.13 167.897L282.334 167.777C285.565 167.727 288.767 168.396 291.708 169.735C294.648 171.074 297.254 173.049 299.336 175.517C301.238 177.748 302.53 180.431 303.086 183.308C303.146 183.697 303.206 184.087 303.236 184.477C303.266 184.866 303.276 185.335 303.276 185.775Z",
    fill: "url(#paint12_linear_578_5674)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M252.111 167.897L221.348 168.027C218.184 168.01 215.057 168.698 212.194 170.04C209.331 171.383 206.803 173.346 204.796 175.787C202.567 178.409 201.223 181.667 200.955 185.096C201.209 181.565 202.614 178.215 204.956 175.558C207.035 173.086 209.64 171.109 212.582 169.77C215.523 168.431 218.726 167.764 221.958 167.817L252.111 167.897Z",
    fill: "url(#paint13_linear_578_5674)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M282.685 213.162C282.235 189.331 279.014 184.616 283.775 178.953C285.792 176.491 288.59 174.789 291.706 174.129C294.63 173.624 297.64 174.11 300.257 175.507C309.808 180.911 306.978 204.333 300.687 219.125C299.317 222.341 295.686 230.99 291.156 230.79C289.316 230.701 287.955 229.162 287.005 228.044C282.805 223.13 282.755 216.737 282.685 213.162Z",
    fill: "url(#paint14_linear_578_5674)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M287.036 228.144C286.126 229.562 285.156 230.93 284.116 232.269C283.786 231.929 283.496 231.589 283.226 231.27C279.025 226.356 278.975 219.984 278.915 216.388C278.455 192.557 275.225 187.852 279.995 182.179C281.042 180.919 282.293 179.842 283.696 178.993C278.995 184.636 282.196 189.391 282.646 213.152C282.716 216.747 282.766 223.14 286.966 228.044C287.036 228.084 287.036 228.104 287.036 228.144Z",
    fill: "url(#paint15_linear_578_5674)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M300.547 193.316C300.309 190.532 299.779 187.78 298.967 185.106C297.706 180.182 296.136 177.775 297.156 176.826C297.826 176.207 299.157 176.626 299.437 176.726C303.947 178.154 305.337 186.614 305.147 191.898C305.027 195.134 304.237 198.759 303.047 198.889C302.869 198.908 302.689 198.891 302.517 198.84C302.345 198.788 302.185 198.703 302.047 198.59C300.737 197.451 300.647 195.264 300.547 193.316Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M303.648 202.355C303.65 202.541 303.596 202.724 303.494 202.879C303.392 203.035 303.246 203.157 303.074 203.229C302.903 203.302 302.713 203.322 302.53 203.287C302.347 203.252 302.179 203.163 302.046 203.032C301.914 202.901 301.823 202.734 301.786 202.552C301.749 202.369 301.767 202.18 301.838 202.008C301.909 201.836 302.029 201.689 302.184 201.585C302.339 201.481 302.521 201.426 302.708 201.426C302.955 201.426 303.193 201.524 303.369 201.697C303.545 201.871 303.645 202.108 303.648 202.355Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M250.74 289C277.844 289 299.816 280.016 299.816 268.934C299.816 257.852 277.844 248.869 250.74 248.869C223.636 248.869 201.664 257.852 201.664 268.934C201.664 280.016 223.636 289 250.74 289Z",
    fill: "url(#paint16_radial_578_5674)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M114.524 0H47.4658C21.2512 0 0 21.2206 0 47.3976C0 73.5746 21.2512 94.7952 47.4658 94.7952H114.524C140.739 94.7952 161.99 73.5746 161.99 47.3976C161.99 21.2206 140.739 0 114.524 0Z",
    fill: "url(#paint17_linear_578_5674)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9158 65.5406C50.9158 66.08 49.3256 66.4295 46.0852 66.5394C42.8448 66.6493 41.2046 66.5394 41.1846 65.9401L40.6746 54.9335L33.9237 55.2431L34.4338 66.3097C34.4338 66.8557 32.8236 67.1886 29.6032 67.3085C26.3628 67.4583 24.7326 67.3085 24.7026 66.7092L23.2324 34.8378C23.2324 34.1719 24.8393 33.7624 28.053 33.6093C31.2667 33.4561 32.9036 33.7192 32.9636 34.3983L33.4837 45.7046L40.2345 45.395L39.7145 34.1786C39.7145 33.7291 40.4845 33.3696 42.0847 33.1099C42.9148 33.01 43.7349 32.9401 44.535 32.9001H46.9953C48.6055 33.02 49.4256 33.3097 49.4456 33.7491L50.9158 65.5406Z",
    fill: "url(#paint18_linear_578_5674)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6794 64.0123C71.3558 65.3876 68.7094 66.125 66.0085 66.1498C64.5175 66.2517 63.0214 66.0492 61.6114 65.5547C60.2014 65.0601 58.9071 64.2838 57.8075 63.2732C55.5272 61.2091 54.297 58.2593 54.117 54.424C53.8069 51.0562 54.7821 47.6957 56.8473 45.0154C57.7853 43.8371 58.9711 42.8792 60.321 42.2096C61.6708 41.5399 63.1515 41.1747 64.6583 41.1401C67.872 40.9936 70.3923 41.696 72.2192 43.2475C73.092 43.9607 73.8022 44.8517 74.3024 45.8611C74.8026 46.8705 75.0812 47.9749 75.1196 49.1004C75.3596 54.2941 72.4926 57.0275 66.5185 57.3005L63.1881 57.4503C63.1577 57.831 63.2232 58.2133 63.3787 58.5622C63.5342 58.9111 63.7747 59.2156 64.0782 59.4479C64.8035 59.8263 65.6255 59.9793 66.4385 59.8873C68.6678 59.7913 70.8417 59.1647 72.7793 58.0596C72.7793 58.0596 72.9593 58.2393 73.2394 58.7088C73.9594 59.7262 74.4132 60.9073 74.5595 62.1446C74.6156 62.5081 74.5618 62.8799 74.405 63.2127C74.2482 63.5454 73.9956 63.8238 73.6794 64.0123ZM67.0086 50.3789C67.0377 50.1062 67.0028 49.8305 66.9068 49.5737C66.8108 49.3168 66.6563 49.0857 66.4555 48.8987C66.2547 48.7117 66.0131 48.574 65.7498 48.4963C65.4865 48.4186 65.2087 48.4032 64.9383 48.4512C64.3653 48.4663 63.8175 48.6901 63.3982 49.0804C63.1842 49.2922 63.0209 49.5495 62.9205 49.8332C62.82 50.1168 62.785 50.4194 62.8181 50.7185L62.8881 52.2066L65.4884 52.0868C65.7097 52.1052 65.9322 52.0719 66.1383 51.9896C66.3444 51.9072 66.5285 51.7781 66.676 51.6123C66.8235 51.4466 66.9304 51.2489 66.9881 51.0348C67.0458 50.8207 67.0528 50.5961 67.0086 50.3789Z",
    fill: "url(#paint19_linear_578_5674)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6912 64.2822C87.6912 64.5752 86.061 64.7949 82.8006 64.9414C80.2269 65.0346 78.9368 64.9647 78.9301 64.7316L77.4199 31.9613C77.4199 31.4719 78.9401 31.1623 82.0605 31.0225C84.7908 31.0225 86.161 31.0924 86.171 31.3121L87.6912 64.2822Z",
    fill: "url(#paint20_linear_578_5674)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.793 63.6828C100.793 63.9692 99.1625 64.1889 95.9021 64.342C93.3085 64.4219 92.0117 64.352 92.0117 64.1323L90.5215 31.362C90.5215 30.8826 92.0417 30.5729 95.1621 30.4331C97.8924 30.4331 99.2726 30.503 99.2826 30.7228L100.793 63.6828Z",
    fill: "url(#paint21_linear_578_5674)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.114 60.9262C105.007 58.8021 103.863 55.7824 103.683 51.8671C103.503 47.9519 104.367 44.8423 106.274 42.5384C108.339 40.316 111.196 38.9931 114.228 38.8548C117.261 38.7165 120.227 39.7741 122.486 41.7993C124.576 43.9168 125.716 46.9431 125.896 50.8484C126.076 54.7536 125.216 57.8399 123.326 60.1771C122.354 61.336 121.139 62.2676 119.767 62.9061C118.394 63.5447 116.899 63.8746 115.385 63.8726C113.875 64.0094 112.353 63.8168 110.925 63.308C109.497 62.7993 108.196 61.9866 107.114 60.9262ZM114.625 46.9431C112.811 47.023 111.974 48.5412 112.114 51.4976C112.245 54.494 113.225 55.8823 115.035 55.7924C116.845 55.7025 117.695 54.1943 117.555 51.2479C117.415 48.3015 116.445 46.8133 114.625 46.9431Z",
    fill: "url(#paint22_linear_578_5674)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M129.536 55.5128C129.536 55.2931 131.017 55.1133 133.977 54.9735C136.937 54.8336 138.427 54.8636 138.447 55.0634L138.758 61.985C138.758 62.3046 137.297 62.5343 134.327 62.6741C131.357 62.814 129.866 62.784 129.856 62.5842L129.536 55.5128ZM137.347 52.2667C137.347 52.4565 136.217 52.6063 133.917 52.7062C131.617 52.8061 130.467 52.7861 130.467 52.6263L128.406 28.965C128.406 28.7053 129.856 28.5055 132.797 28.3757C135.737 28.2458 137.207 28.2858 137.217 28.5055L137.347 52.2667Z",
    fill: "url(#paint23_linear_578_5674)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M136.127 47.6724C136.127 47.6724 134.227 30.4932 135.127 30.0237C136.027 29.5543 136.557 38.9529 136.127 47.6724Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.018 56.3418C138.018 56.5394 137.959 56.7325 137.849 56.8967C137.739 57.061 137.583 57.189 137.4 57.2646C137.218 57.3402 137.017 57.3599 136.823 57.3214C136.629 57.2829 136.45 57.1877 136.311 57.0481C136.171 56.9084 136.075 56.7304 136.037 56.5367C135.998 56.3429 136.018 56.1421 136.094 55.9596C136.169 55.7771 136.298 55.6211 136.462 55.5113C136.627 55.4016 136.82 55.343 137.018 55.343C137.283 55.343 137.537 55.4482 137.725 55.6356C137.912 55.8229 138.018 56.0769 138.018 56.3418Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.476 48.8209C124.518 46.6637 123.772 44.5651 122.376 42.9181C121.759 42.1882 120.994 41.5966 120.133 41.1818C119.271 40.767 118.331 40.5384 117.375 40.511C117.185 40.511 116.505 40.6508 116.465 40.9305C116.375 41.5198 119.115 41.9293 121.176 43.4574C122.856 44.8175 124.02 46.7098 124.476 48.8209Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7515 31.0325C98.8016 31.0325 99.2017 50.2892 98.9017 53.7749C98.6016 57.2607 97.3215 31.0325 97.7515 31.0325Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8888 47.5225C73.4187 44.9256 70.4483 41.9992 68.5881 42.4586C66.7279 42.9181 70.7884 44.3164 72.2485 45.5749C73.7087 46.8333 73.8888 47.5225 73.8888 47.5225Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5671 62.3645C58.9413 63.8873 60.8202 64.8627 62.8577 65.1112C62.8577 65.0113 59.4773 64.5519 57.6771 61.8052C56.827 60.5168 55.9869 58.1796 55.4368 58.1796C55.4274 58.1752 55.4172 58.1729 55.4068 58.1729C55.3964 58.1729 55.3862 58.1752 55.3768 58.1796C55.0868 58.4093 56.1869 60.8364 57.5671 62.3645Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6551 61.9251C48.9751 62.874 48.8751 38.5634 48.435 36.1863V35.9566C48.435 35.8067 48.435 35.4871 48.435 34.8679C48.4079 34.6122 48.3224 34.3662 48.185 34.1488C47.2849 33.3397 43.3244 33.7492 45.0146 33.5295C46.2289 33.3612 47.463 33.3984 48.665 33.6394C48.8651 33.7093 48.8751 34.0788 48.9151 34.2187C49.7652 39.0528 50.5753 60.6267 49.6551 61.9251Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M156.019 35.6468C154.958 36.4358 147.618 22.243 129.285 12.5148C119.014 7.04141 110.583 5.84286 110.803 4.84407C111.063 3.67549 123.085 3.24601 133.986 8.68941C150.348 16.8695 157.179 34.8078 156.019 35.6468Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M157.41 42.3688C158.101 42.3688 158.66 41.8098 158.66 41.1203C158.66 40.4308 158.101 39.8718 157.41 39.8718C156.72 39.8718 156.16 40.4308 156.16 41.1203C156.16 41.8098 156.72 42.3688 157.41 42.3688Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.178 7.05156C64.0387 7.05156 67.9791 6.15721 67.9791 5.05398C67.9791 3.95074 64.0387 3.0564 59.178 3.0564C54.3173 3.0564 50.377 3.95074 50.377 5.05398C50.377 6.15721 54.3173 7.05156 59.178 7.05156Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7604 5.05383C78.7604 5.65311 77.6902 6.14252 76.3701 6.14252C75.0499 6.14252 74.0098 5.65311 74.0098 5.05383C74.0098 4.45456 75.0599 3.99512 76.3701 3.99512C77.6802 3.99512 78.7604 4.46455 78.7604 5.05383Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5936 40.3212C32.7636 43.3875 32.7436 45.8745 32.5336 45.8944C32.3235 45.9144 32.0235 43.4274 31.8435 40.3611C31.6635 37.2949 31.7035 34.8079 31.9035 34.7979C32.1035 34.7879 32.4236 37.2549 32.5936 40.3212Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.648 100.878C146.079 104.873 147.579 107.23 147.239 107.45C146.899 107.67 144.238 105.143 142.738 101.787C140.058 95.9239 141.498 89.5716 142.068 89.5516C142.638 89.5316 142.208 94.0561 144.648 100.878Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_5674",
    x1: 122.945,
    y1: 78.4049,
    x2: 135.776,
    y2: 113.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#67E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_578_5674",
    x1: 192.748,
    y1: 177.568,
    x2: 281.912,
    y2: 246.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0891B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_578_5674",
    x1: 238.309,
    y1: 26.0684,
    x2: 253,
    y2: 23.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_578_5674",
    x1: 234.558,
    y1: 63.3434,
    x2: 260.603,
    y2: 33.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_578_5674",
    x1: 196.775,
    y1: 165.22,
    x2: 300,
    y2: 61.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_578_5674",
    x1: 248.02,
    y1: 126.607,
    x2: 248.938,
    y2: 85.3267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E293B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_5674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.028 105.652) scale(17.1821 17.1592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_578_5674",
    x1: 213.556,
    y1: 105.652,
    x2: 234.489,
    y2: 105.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E293B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_5674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.923 105.652) scale(17.1821 17.1592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_578_5674",
    x1: 260.463,
    y1: 105.652,
    x2: 281.395,
    y2: 105.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E293B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_578_5674",
    x1: 235.079,
    y1: 8.34997,
    x2: 254.53,
    y2: 5.50599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_578_5674",
    x1: 247.661,
    y1: 142.637,
    x2: 277.545,
    y2: 112.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_578_5674",
    x1: 219.396,
    y1: 233.337,
    x2: 298.564,
    y2: 140.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0891B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#67E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_578_5674",
    x1: 215.197,
    y1: 187.233,
    x2: 262.809,
    y2: 131.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_578_5674",
    x1: 317.266,
    y1: 220.042,
    x2: 257.845,
    y2: 176.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0891B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#67E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A5F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_578_5674",
    x1: 265.333,
    y1: 215.319,
    x2: 307.385,
    y2: 193.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_5674",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.239 268.33) scale(48.9809 19.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_578_5674",
    x1: 0,
    y1: 47.4026,
    x2: 161.99,
    y2: 47.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_578_5674",
    x1: 25.5341,
    y1: 53.1231,
    x2: 154.866,
    y2: 19.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7DD3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_578_5674",
    x1: 28.2201,
    y1: 63.3981,
    x2: 157.553,
    y2: 29.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_578_5674",
    x1: 27.9276,
    y1: 62.2619,
    x2: 157.25,
    y2: 28.4886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_578_5674",
    x1: 28.6195,
    y1: 64.8997,
    x2: 157.942,
    y2: 31.1264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_578_5674",
    x1: 30.796,
    y1: 73.2485,
    x2: 160.128,
    y2: 39.4747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_578_5674",
    x1: 30.5532,
    y1: 72.3299,
    x2: 159.886,
    y2: 38.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F2FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_5674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 289,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthVector);
export default __webpack_public_path__ + "static/media/auth-vector.d05cfd4f72866714f2e25c9fc72f7d8f.svg";
export { ForwardRef as ReactComponent };